import { Grid, LinearProgress } from '@material-ui/core'
import { useEffect } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import Talk from 'talkjs'
import { getConversation } from '../../../actions/applications'
import { openDialog } from '../../../actions/dialogs'
import { denyReservable, reserveShowing } from '../../../actions/showings'
import {
  DenyReservableAction,
  ReserveShowingAction,
  OpenDialog
} from '../../../actions/types'
import { selectConversation } from '../../../selectors/applications'
import {
  selectReserve,
  selectReserveLoading
} from '../../../selectors/showings'
import { ApplicationStatus } from '../../../types/applications'
import { ReservableShowings } from '../../../types/showings'
import { ReserveInterface, StateInterface } from '../../../types/states'
import {
  get,
  TalkUser,
  getConversationById,
  initialize,
  addPopup
} from '../../../utils/talkChat'
import { StatusInfo } from './InfoViews'
import NotAvailable from './NotAvailable'
import ReserveView from './ReserveView'

interface ReserveShowingProps extends WithTranslation {
  conversation: any
  reserve: ReserveInterface
  reserveShowingAction: ReserveShowingAction
  denyReservableAction: DenyReservableAction
  reservableShowings: ReservableShowings | []
  reserveLoading: boolean
  openDialogAction: OpenDialog
  getConversation: any
}

const ReserveShowing = ({
  t,
  conversation,
  reserve,
  reserveShowingAction,
  denyReservableAction,
  reserveLoading,
  openDialogAction,
  getConversation
}: ReserveShowingProps) => {
  let chatPopup: Talk.Popup
  const hasErrored = !!reserve?.reserveViewLogic?.error
  const hasReservation = reserve?.reserveData?.reserved
  const status = reserve.reserveData?.application.status

  const unreadMessageEvent = () => {
    if (window.talkSession) {
      window.talkSession.unreads.on(
        'change',
        function (unreadConversations: any) {
          console.log('i will check unread messages res', unreadConversations)
          if (unreadConversations && unreadConversations.length > 0)
            chatPopup.show()
        }
      )
    }
  }

  const initiateConversation = async () => {
    const selfUserChat: TalkUser = {
      id: reserve.reserveData?.application.applicationId || '',
      name: reserve.reserveData?.application.name || '',
      role: 'applicant'
    }
    await initialize(selfUserChat)

    const conversation = await getConversationById(
      reserve.reserveData?.application.applicationId || ''
    )

    return conversation
  }

  const showChatPopup = async (conversation: any) => {
    const session = await get()
    chatPopup = session.createPopup()
    chatPopup.select(conversation)
    chatPopup.mount({ show: false })
    addPopup(chatPopup)
  }

  useEffect(() => {
    console.log('conversation', conversation)
    const checkConversation = async () => {
      if (conversation?.conversation?.conversationData?.custom?.subject) {
        const conversation = await initiateConversation()
        if (conversation) {
          await showChatPopup(conversation)
          unreadMessageEvent()
        }
      }
    }

    checkConversation()
  }, [conversation])

  useEffect(() => {
    if (reserve.reserveData?.application) {
      getConversation(reserve.reserveData?.application?.applicationId)
    }
  }, [reserve.reserveData?.application])

  if (
    status === ApplicationStatus.notInterested ||
    status === ApplicationStatus.rejected
  ) {
    return <NotAvailable t={t} />
  } else {
    return (
      <Grid
        container
        justify='center'
        // style={reserve.reserveData?.reserved ? {} : { background: '#F1F2F4' }}
      >
        {reserveLoading ? (
          <LinearProgress />
        ) : (
          !hasErrored &&
          reserve?.reserveData && (
            <ReserveView
              reserve={reserve}
              reserveData={reserve.reserveData}
              t={t}
              reserveShowing={reserveShowingAction}
              denyReservable={denyReservableAction}
              openDialog={openDialogAction}
            />
          )
        )}

        {hasErrored && !hasReservation && <StatusInfo reserve={reserve} />}
      </Grid>
    )
  }
}

const mapStateToProps = (state: StateInterface) => {
  return {
    reserveLoading: selectReserveLoading(state),
    reserve: selectReserve(state),
    conversation: selectConversation(state)
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  reserveShowingAction: (showingId: string) =>
    dispatch(reserveShowing(showingId)),
  denyReservableAction: (type: 'bestReservable' | 'reservable') =>
    dispatch(denyReservable(type)),
  openDialogAction: (dialogId: string) => dispatch(openDialog(dialogId)),
  getConversation: (applicationId: string) =>
    dispatch(getConversation(applicationId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ReserveShowing))
